(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-page-three-item-line"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const containers = document.querySelectorAll('.info-tabs-container[data-padding]');
    
    containers.forEach(function(container) {
      const paddingValue = parseInt(container.getAttribute('data-padding'));
      
      function updatePadding() {
        if (window.innerWidth <= 768) {
          container.style.padding = `0 ${Math.min(paddingValue, 16)}px`;
        } else {
          container.style.padding = `0 ${paddingValue}px`;
        }
      }
      
      updatePadding();
      window.addEventListener('resize', updatePadding);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
